import React, { ComponentProps } from "react";
import { useTranslation } from "react-i18next";
import { Trustpilot as TrustpilotWidget } from "../../atoms/Trustpilot/Trustpilot";
import "./TrustPilot.scss";

type Props = Omit<ComponentProps<typeof TrustpilotWidget>, "template">;

export const TrustPilot: React.FC<Props> = (trustpilotProps) => {
  const { t } = useTranslation("ui");

  return (
    <div className="trustpilot" id="trustpilot-section">
      <div className="text-wrapper">
        <h2 className="has-text-weight-normal is-family-secondary">
          {t(
            "Destination_Trustpilot",
            "90,000+ travelers have had a more authentic, tailor-made vacation with us"
          )}
        </h2>
      </div>
      <div className="widget-wrapper">
        <TrustpilotWidget {...trustpilotProps} template="carousel" theme="dark" />
      </div>
    </div>
  );
};
